import { filter, get } from 'lodash';

export type Order = 'asc' | 'desc';

type Comparator<T> = (a: T, b: T) => number;

function descendingComparator<T>(a: T, b: T, orderByPath: string): number {
	const aValue = get(a, orderByPath);
	const bValue = get(b, orderByPath);

	// Normalise undefined / null for predictable comparisons
	const av = aValue === undefined || aValue === null ? '' : aValue;
	const bv = bValue === undefined || bValue === null ? '' : bValue;

	if (bv < av) return -1;
	if (bv > av) return 1;
	return 0;
}

export function getComparator<T>(order: Order, orderBy: keyof T | string): Comparator<T> {
	const path = String(orderBy);
	return order === 'desc' ? (a, b) => descendingComparator(a, b, path) : (a, b) => -descendingComparator(a, b, path);
}

export function applySortFilter<T>({
	list,
	comparator,
	query,
	orderBy,
}: {
	list: T[];
	comparator: Comparator<T>;
	query: string;
	orderBy: keyof T | string;
}): T[] {
	const stabilizedThis = list.map((el, index) => [el, index] as const);
	stabilizedThis.sort((a, b) => {
		const orderResult = comparator(a[0], b[0]);
		if (orderResult !== 0) return orderResult;
		return a[1] - b[1];
	});

	if (query) {
		const path = String(orderBy);
		return filter(list, (dataSet: T) => {
			const value = get(dataSet, path);
			if (typeof value === 'string') {
				return value.toLowerCase().includes(query.toLowerCase());
			}
			return false; // Skip non-string fields
		});
	}

	return stabilizedThis.map((el) => el[0]);
}
